import clsx from 'clsx';
import { PageProps } from 'gatsby';
import { Fragment, useContext, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { Link } from 'components';

import { KOHOLogo } from 'images/logos/koho/KOHOLogo';

import { IQueryParams } from 'typescriptDefs';

import { useScrolled } from 'helpers';
import { generalAppsFlyerIds } from 'helpers/getAfTracking';
import { urlHideNavBarRegex } from 'utils/constants';

import { GetKOHOBtn } from '../GetKOHOBtn';
import { LocaleContext } from '../Layout';

export const NavbarLogoAndCTA = ({
  className,
  ctaTo,
  darkBg,
  navOpen,
  pageName,
  pageVariant,
  location: { pathname, search },
  queryParams,
}: {
  className?: string;
  ctaTo?: string;
  darkBg: boolean;
  navOpen: boolean;
  pageName: string;
  pageVariant?: string;
  location: PageProps['location'];
  queryParams: IQueryParams;
}): JSX.Element => {
  const locale = useContext(LocaleContext);
  const [showCta, showCtaSet] = useState(false);

  const scrolled = useScrolled();

  useEffect(() => {
    // show cta only if mobile nav isn't open, and user has scrolled more than a screen's height
    showCtaSet(scrolled > window.innerHeight && !navOpen);
  }, [scrolled, navOpen]);

  return (
    <Fragment>
      <div
        className={twMerge(
          clsx('flex h-full items-center lg:hidden [&>div]:transition-opacity [&>div]:duration-[0.3s]', className),
        )}
      >
        {pathname.match(urlHideNavBarRegex) === null && (
          <div
            className={twMerge(
              clsx('pointer-events-none absolute opacity-0', showCta && 'pointer-events-auto relative opacity-100'),
            )}
          >
            <GetKOHOBtn
              buttonSize="sm"
              buttonVariant={darkBg ? 'primaryInverse' : 'primary'}
              buttonLocation="Navbar logo and button"
              queryParams={{
                hash: queryParams.hash,
                search: {
                  ...queryParams.search,
                  af_adset_id: generalAppsFlyerIds.NAV_SCROLLED,
                },
              }}
              trackEventProps={{
                category: pageName,
                label: 'Navbar logo and button',
                locale,
                location: pageVariant,
              }}
              to={ctaTo}
            />
          </div>
        )}
        <div
          className={twMerge(
            clsx('pointer-events-auto relative opacity-100', showCta && 'pointer-events-none absolute opacity-0'),
          )}
        >
          <Link
            aria-label={{ en: 'Redirect to home page', fr: "Rediriger vers page d'accueil" }[locale]}
            to={`/${search}`}
          >
            <KOHOLogo className={twMerge(clsx('h-18 w-72 text-primary-400', darkBg && 'text-secondary-75'))} />
          </Link>
        </div>
      </div>
      <Link
        aria-label={
          {
            en: 'Redirect to home page',
            fr: "Rediriger vers page d'accueil",
          }[locale]
        }
        className="mr-2 hidden lg:mr-40 lg:block"
        to={`/${search}`}
      >
        <div>
          <KOHOLogo className={twMerge(clsx('text-primary-400', darkBg && 'text-secondary-75'))} />
        </div>
      </Link>
    </Fragment>
  );
};
